export default "__VITE_ASSET__zQ8ycFkl__"